import { useSignalsApiStatusPollingQuery } from "app/pages/sales-intelligence/modules/management/sub-modules/signals-api/query/queries/useSignalsApiStatusPollingQuery";
import salesSettingsHelper from "app/pages/sales-intelligence/services/salesSettingsHelper";
import type { SignalsApiStatusResponse } from "app/pages/sales-intelligence/sub-modules/management/types";

export interface ISignalsApiData {
    data: SignalsApiStatusResponse | undefined;
    isFetching: boolean;
    isStale: boolean;
    isEnabled: boolean;
    hasAccess: boolean;
    isConfigured: boolean;
    subscribedDomainsCount: number;
    signalsCount: number;
}

const useSignalsApiData = (): ISignalsApiData => {
    const isEnabled = salesSettingsHelper.isSalesApiSignalsEnabled;
    const hasAccess = salesSettingsHelper.hasApiSignalsAccess();

    const { data, isFetching, isStale } = useSignalsApiStatusPollingQuery();

    const subscribedDomainsCount = data?.subscribedDomainsCount ?? 0;
    const signalsCount = data?.signalsCount ?? 0;
    const isConfigured = isEnabled && !!data?.isWebhooksConfigured && signalsCount > 0 && subscribedDomainsCount > 0;

    return {
        data,
        isFetching,
        isStale,
        isEnabled,
        hasAccess,
        isConfigured,
        subscribedDomainsCount,
        signalsCount,
    };
};

export default useSignalsApiData;
